/**
 * Authors: mariushirjanu
 * Created: 01/06/2021
 */
import { Component, Input } from '@angular/core';

/**
 * This component covers the following cases:
 *  1) <activity-indicator></activity-indicator>                                -> Display only the spinner without any text
 *  2) <activity-indicator useDefaultText="true"></activity-indicator>          -> Display the spinner with the default text 'Loading...':
 *  3) <activity-indicator text="GA.GENERAL.SEARCHING"></activity-indicator>    -> Display the spinner and a custom text 'Searching...':
 *  4) <activity-indicator toLoad="GA.GENERAL.FAQ"></activity-indicator>        -> Display the spinner with a custom text to load - 'Loading FAQ...':
 */
@Component({
  selector: 'activity-indicator',
  template: `
    <span class="no-margin">
      <i class="fa fa-spinner fa-spin activity-indicator"></i>
      <span *ngIf="!toLoad">
        <span *ngIf="!text && useDefaultText" translate="GA.LOADING_SIMPLE"></span><span *ngIf="text" [translate]="text"></span><span *ngIf="text || useDefaultText">…</span>
      </span>
      <span *ngIf="toLoad">
        <span translate="GA.LOADING" [translateParams]="{toload: (toLoad | translate)}"></span>
      </span>
    </span>
  `
})
export class ActivityIndicatorComponent {
  @Input() public useDefaultText?:boolean;
  @Input() public text?:string;
  @Input() public toLoad?:string;
}